import React, { useState } from "react";
import { createPortal } from "react-dom";
import styles from "@/styles/desktop/FooterMoveBrasil.module.scss";
import SacContactModal from "@/app/components/SacContactModal/SacContactModal";

type FooterProps = {
  logoSrc: string;
  companyInfo: string;
  copyrightInfo: string;
  safetyLogoSrc: string;
  safetyText: string;
};

const Footer: React.FC<FooterProps> = ({
  logoSrc,
  companyInfo,
  copyrightInfo,
  safetyLogoSrc,
  safetyText,
}) => {
  const [sacModalOpen, setSacModalOpen] = useState(false);
  return (
    <footer className={styles.footer}>
    <div className={styles.container}>
      <div className={styles.companyInfo}>
        <img
          loading="lazy"
          src={logoSrc}
          alt="Company logo"
          className={styles.logo}
        />
        <div className={styles.info}>{companyInfo}</div>
      </div>
      <div className={styles.safety}>
        <img
          loading="lazy"
          src={safetyLogoSrc}
          alt="Safety logo"
          className={styles.logo}
        />
        <div className={styles.text}>{safetyText}</div>
      </div>
    </div>
        <div className={styles.copyright}>{copyrightInfo}</div>
        <div className={styles.footerLinks}>
			<a
				href="#"
				onClick={(e) => { e.preventDefault(); setSacModalOpen(true); }}
			>SAC</a>
			<a href="https://privacidadecomercio.aguiabranca.com.br/" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>
			<a href="https://www.contatoseguro.com.br/compliancecomercio" target="_blank" rel="noopener noreferrer">Canal de Denúncia</a>
		</div>
		{sacModalOpen && createPortal(
			<SacContactModal onClose={() => setSacModalOpen(false)} />,
			document.body
		)}
  </footer>
);
}

export default Footer;
